module.exports = __webpack_public_path__ + "img/culture1.114c2d7e.jpg";